import { Component, inject, input, output, viewChild } from '@angular/core';
import { SwalComponent, SwalPortalTargets } from '@sweetalert2/ngx-sweetalert2';

@Component({
  selector: 'app-review-submission-failed-modal',
  templateUrl: './review-submission-failed-modal.component.html',
  standalone: false,
})
export class ReviewSubmissionFailedModalComponent {
  public swalTargets = inject(SwalPortalTargets);
  private swalRef = viewChild<SwalComponent>('failedSwal');

  readonly title = input<string>('Submission failed 😢');
  readonly message = input<string>('Failed to submit the review. You can file an error report and copy the error details below.');
  readonly showCancelButton = input<boolean>(true);
  readonly showConfirmButton = input<boolean>(false);
  readonly cancelButtonText = input<string>('Go back');
  readonly confirmButtonText = input<string>('Next review');

  readonly errorMessage = input<string | undefined>(undefined);

  readonly confirm = output<void>();
  readonly dismiss = output<void>();
  readonly copyDetails = output<void>();

  open(): void {
    this.swalRef()?.fire();
  }
}
